import { useGetAbApiDataQuery } from '@/src/api/rtkQuery/abApi'
import { useMemo } from 'react'
import { isInternalUser } from '@/src/utils/generalUtils/checkUserLogin'

// Hook to determine sign-in flow variant ('otp' | 'old') based on AB API response
// Internal users (cleartrip/flyin.com emails) always get OTP flow
export const useSignInFlowVariant = () => {
    const { data: abApiData } = useGetAbApiDataQuery()

    const variant = useMemo(() => {
        // Internal users always get OTP flow
        if (typeof window !== 'undefined' && isInternalUser()) {
            return 'otp'
        }

        if (!abApiData) {
            return 'old'
        }

        // 'a' = OTP flow, 'b' = old email/password flow
        const signInFlow = abApiData.signInFlow

        if (signInFlow === 'b') {
            return 'otp'
        }

        return 'old'
    }, [abApiData])

    return {
        variant
    }
}

export default useSignInFlowVariant
